function getIsIphoneX() {
  if (process.server) return false
  return (
    /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812
  )
}
function getIsWeChat() {
  if (process.server) return false
  const userAgent = navigator.userAgent.toLowerCase()

  // @ts-ignore
  if (userAgent.match(/MicroMessenger/i) === 'micromessenger') {
    return true
  } else {
    return false
  }
}

function getIsIphone() {
  if (process.server) return false
  return navigator.userAgent.match(/(iPhone)/)
}

function getIsIos() {
  return process.server
    ? false
    : /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
}
function getIsAndroid() {
  if (process.server) return false
  if (navigator.userAgent.match(/(Android)/) === null) {
    return false
  }
  return true
}

const isDuApp = process.server
  ? false
  : /poizon/.test(navigator.userAgent.toLowerCase())
const isWeChat = process.server
  ? false
  : /micromessenger/.test(navigator.userAgent.toLowerCase())
const isAndroid = process.server
  ? false
  : !!navigator.userAgent.match(/(Android)/)
const isIOS = process.server
  ? false
  : /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)

const isFacebook = process.server
  ? false
  : /(FBAN|FBAV)/i.test(navigator.userAgent)

function getAppVersion() {
  if (process.server) return '0'
  const res = /Poizon\/(\d+(\.\d+){0,2})/.exec(navigator.userAgent)
  if (res === null) return '0'
  return res[1]
}
const appVersion = getAppVersion()
console.log(appVersion, 'appVersion111');
export { isDuApp, isAndroid, isIOS, isWeChat, appVersion, isFacebook }

export default {
  getIsIphoneX,
  getIsWeChat,
  getIsIphone,
  getIsAndroid,
  getIsIos
}
